module.exports = __webpack_public_path__ + "static/media/LaurenSantee.d4258144.jpg";